export const CUSTOM_JOIN = {
  SAVE_JOIN: 'CUSTOM_JOIN/SAVE_JOIN',
  SAVE_JOIN_SUCCESS: 'CUSTOM_JOIN/SAVE_JOIN_SUCCESS',
  SAVE_JOIN_ERROR: 'CUSTOM_JOIN/SAVE_JOIN_ERROR',
  FETCH_JOIN: 'CUSTOM_JOIN/FETCH_JOIN',
  FETCH_JOIN_SUCCESS: 'CUSTOM_JOIN/FETCH_JOIN_SUCCESS',
  FETCH_JOIN_ERROR: 'CUSTOM_JOIN/FETCH_JOIN_ERROR',
  RESET: 'CUSTOM_JOIN/RESET',
};
